// extracted by mini-css-extract-plugin
module.exports = {"container":"landing-feature-policy-pages_container__AO5_d","title":"landing-feature-policy-pages_title__RqK8H"};